import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css';

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-venta-producto'}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "200px" }}>{value}</div>
                    )
                },
                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Unidad Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Valor Unitario',
                    dataIndex: 'precioUnitarioStr',
                    key: 'precioUnitarioStr',
                    className: props.columnVisible.nombreCliente,
                    sorter: true,
                },
                {
                    title: 'Cliente',
                    dataIndex: 'nombreCliente',
                    key: 'nombreCliente',
                    className: props.columnVisible.nombreCliente,
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "200px" }}>{value}</div>
                    )
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    className: props.columnVisible.tipoDocumentoCliente,
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    className: props.columnVisible.numeroDocumentoCliente,
                    sorter: true
                },
                {
                    title: 'Tipo',
                    dataIndex: 'tipoComprobanteSunat',
                    key: 'tipoComprobanteSunat',
                    className: props.columnVisible.tipo,
                    sorter: true
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    className: props.columnVisible.serie,
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    className: props.columnVisible.documento,
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    className: props.columnVisible.fecha,
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    className: props.columnVisible.tipoCambio,
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Soles',
                    className: 'parent-group ' + props.columnVisible.grupoSoles,
                    children: [
                        {
                            title: 'Sub Total',
                            dataIndex: 'subTotalSolesStr',
                            key: 'subTotalSolesStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.subTotalSoles,
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'igvSolesStr',
                            key: 'igvSolesStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.igvSoles,
                            sorter: true
                        },
                        {
                            title: 'Total',
                            dataIndex: 'totalSolesStr',
                            key: 'totalSolesStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.totalSoles,
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Dólares',
                    className: 'parent-group ' + props.columnVisible.grupoDolares,
                    children: [
                        {
                            title: 'Sub Total',
                            dataIndex: 'subTotalDolaresStr',
                            key: 'subTotalDolaresStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.subTotalDolares,
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'igvDolaresStr',
                            key: 'igvDolaresStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.igvDolares,
                            sorter: true
                        },
                        {
                            title: 'Total',
                            dataIndex: 'totalDolaresStr',
                            key: 'totalDolaresStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.totalDolares,
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Conversión a Soles',
                    className: 'parent-group ' + props.columnVisible.grupoConversionSoles,
                    children: [
                        {
                            title: 'Sub Total',
                            dataIndex: 'subTotalSolesConvertidoStr',
                            key: 'subTotalSolesConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.subTotalConversionSoles,
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'igvSolesConvertidoStr',
                            key: 'igvSolesConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.igvConversionSoles,
                            sorter: true
                        },
                        {
                            title: 'Total',
                            dataIndex: 'totalSolesConvertidoStr',
                            key: 'totalSolesConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.totalConversionSoles,
                            sorter: true
                        }
                    ]
                },
                {
                    title: 'Conversión a Dólares',
                    className: 'parent-group ' + props.columnVisible.grupoConversionDolares,
                    children: [
                        {
                            title: 'Sub Total',
                            dataIndex: 'subTotalDolaresConvertidoStr',
                            key: 'subTotalDolaresConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.subTotalConversionDolares,
                            sorter: true
                        },
                        {
                            title: 'IGV',
                            dataIndex: 'igvDolaresConvertidoStr',
                            key: 'igvDolaresConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.igvConversionDolares,
                            sorter: true
                        },
                        {
                            title: 'Total',
                            dataIndex: 'totalDolaresConvertidoStr',
                            key: 'totalDolaresConvertidoStr',
                            align: 'right',
                            className: 'child-group ' + props.columnVisible.totalConversionDolares,
                            sorter: true
                        }
                    ]
                }
            ]}
        />
    );
}